const trains = {
  train: "Former", // translated
  trains: "Les trains", // translated
  fairConditions: "Conditions équitables", // translated
  to: "à", // translated
  earlier: "Plus tôt", // translated
  later: "Plus tard", // translated
  adults: "Adultes", // translated
  child: "Enfant", // translated
  senior: "Senior", // translated
  seniors: "Personnes âgées", // translated
  price: "Prix", // translated
  for: "pour", // translated
  total: "Total", // translated
  selected: "Choisi", // translated
  prebook: "Pré-réservation", // translated
  book: "Livre", // translated
  payment: "Paiement", // translated
  return: "Retour", // translated
  passengers: "Passagers", // translated
  delivery: "Livraison", // translated
  summary: "Résumé", // translated
  checkout: "Vérifier", // translated
  trainToastCorrectFillForm: "Veuillez remplir correctement tous les champs.", // translated
  fareConditions: "Conditions tarifaires", // translated
  travelInfo: "Informations de voyage", // translated
  remarks: "Remarques clients", // translated
  noServices: "Aucun service", // translated
  timesAndSeats: "Horaires et places", // translated
  mobileTicket: "Billet mobile", // translated
  stationTicket: "Retrait à la gare", // translated
  homeTicket: "Imprimer à la maison", // translated
  countryCode: "Code postal", // translated
  chooseTicket: "Choisissez le mode de livraison des billets", // translated
  ticketError: "Veuillez sélectionner un billet pour toutes les destinations", // translated
  ticketDelivery: "Veuillez sélectionner un mode de livraison des billets", // translated
  passengerDetails: "Détails du passager", // translated
  waitWhileProcessingPayment: "Veuillez patienter pendant que nous traitons votre paiement, n'actualisez pas et ne fermez pas la page.", // translated
  reductionCardId: "Identifiant de la carte de réduction", // translated
  countryOfResidence: "Pays de résidence", // translated
  countryOfBirth: "Pays de naissance", // translated
  documentCountry: "Pays du document", // translated
  documentNumber: "Numéro de document", // translated
  expirationDate: "Date d'expiration", // translated
  documentType: "Type de document", // translated
  travelerDocumentInfo: "Informations sur les documents du voyageur", // translated
  youth: "Jeunesse", // translated
  youths: "Jeunes", // translated
  departTimeEarlyFirst: "Heure de départ (au plus tôt en premier)", // translated
};

export default trains;
